import c from './try-free-popup.vue';
import './try-free-popup.sass';

export default c;
